import { useEffect, useRef } from 'react'
import useRoomContextRef from '@/services/useRoomContextRef'
import useMiscRoomActions from '@/services/useMiscRoomActions'
import * as Constants from '@/services/Constants'

export default function useSideBarWidthObserver() {
    const { setRetract } = useMiscRoomActions()

    const { roomStateRef } = useRoomContextRef()

    const divRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const onSideBarWidthExceedThreshold = () => {
            if (roomStateRef.current.isRetracted) {
                setRetract(false, 'sidebar_width_observer', { doNotRestoreSavedWindowDimension: true })
            }
        }

        const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const { width } = entry.contentRect
                if (width > Constants.sidebar_width_threshold) {
                    const { isRetractedInProgress } = roomStateRef.current
                    if (!isRetractedInProgress) {
                        onSideBarWidthExceedThreshold()
                    }
                }
            }
        })

        if (divRef.current) {
            observer.observe(divRef.current)
        }

        return () => observer.disconnect()
    }, [])

    return {
        divRef,
    }
}
